/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaOperatoreDetailDTO } from '../model/models';
import { PraticaPunteggioOverrideForm } from '../model/models';
import { PraticaPunteggioRicalcolaForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface OverrideManualePunteggioPraticaRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaPunteggioOverrideForm: PraticaPunteggioOverrideForm;
}

export interface RicalcolaPunteggioPraticaRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaPunteggioRicalcolaForm: PraticaPunteggioRicalcolaForm;
}


export interface GestionePraticheScoringServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Override manuale operatore del punteggio (bypassa motore). motivo @NotBlank obbligatorio. punteggio_sportello opzionale. Audit PUNTEGGIO_OVERRIDDEN_MANUALMENTE con ScoringManualOverridePayload. Response: 200, 400 motivo blank, 403/404, 409, 422 (G1/G2).
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/punteggio
* @param requestParameters
     */
    overrideManualePunteggioPratica(requestParameters: OverrideManualePunteggioPraticaRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

    /**
     * Force-recalc del punteggio via motore PraticaScoringService. Audit PUNTEGGIO_RICALCOLATO solo se delta non-zero. Response: 200 + detail, 403/404, 409, 422 (G1/G2).
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/ricalcola-punteggio
* @param requestParameters
     */
    ricalcolaPunteggioPratica(requestParameters: RicalcolaPunteggioPraticaRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

}
